// Opens the Video Director from anywhere (library cell, selected scene box, top bar); EditorApp listens.
// detail: { projectId } | { importUrl } | { blank: true, imageUrl?, aspect? } | { latest: true }.
// All but a draft in an earlier step land on the Edit step (the video edit timeline).
export const openInDirector = (detail) =>
  window.dispatchEvent(new CustomEvent("aidea:openDirectorProject", { detail }));
